import React from 'react'
import styles from './index.module.scss'

export default function CustomBadge({ children, color = 'gray', icon }) {
  return (
    <div className={`${styles.badge} ${styles[color]}`}>
      {icon && <span className={styles.icon}>{icon}</span>}
      {children}
    </div>
  )
}
